export default function PageBackground() {
    return (
        <div className="pointer-events-none fixed inset-0 z-0" aria-hidden="true">
            <img
                src="/hero-bg.png"
                alt=""
                data-testid="page-background"
                className="h-full w-full scale-105 object-cover blur-[2px]"
            />
            <div className="absolute inset-0 bg-[#0B1F33]/[0.78]" />
        </div>
    );
}
